/**
 * @Description 开店区域
 */
import { FC, useEffect } from 'react';
import styles from './index.module.less';
import { Switch } from 'antd';
// import { bigdataBtn } from '@/common/utils/bigdata';
import useUpdateEffect from '@/common/hook/updateEffect/useUpdateEffect';
const BorderSwitch:FC<any> = ({
  isOpenBorder,
  setIsOpenBorder,
  setActive,
  isShape
}) => {

  const change = () => {
    setIsOpenBorder(state => !state);
    // bigdataBtn('e53435f1-4934-4ac8-8425-a6bb2547ff21', '选址地图', '开店区域围栏', '点击了开店区域围栏', !isOpenBorder ? '开启' : '关闭');
  };

  useEffect(() => {
    setIsOpenBorder(true);
  }, []);

  useUpdateEffect(() => {
    if (isShape) {
      setIsOpenBorder(true);
    }
  }, [isShape]);

  return <div
    onMouseEnter={() => setActive('')}
    className={styles.card}>
    <span className='mr-16'>开店区域</span>
    <Switch
      className={styles.switch}
      size='small'
      checked={isOpenBorder}
      onChange={change}/>
  </div>;
};
export default BorderSwitch;
